import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('div', {
    staticClass: "card-header border-0 py-5"
  }, [_vm._m(0), _c('div', {
    staticClass: "card-toolbar"
  }, [!_vm.embedded ? _c('router-link', {
    staticClass: "btn btn-light",
    attrs: {
      "to": {
        name: 'centrosCustos'
      }
    }
  }, [_vm._v("Voltar ao cadastro")]) : _vm._e()], 1)]), _c('div', {
    staticClass: "card-body pt-0"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": _vm.embedded ? 6 : 3
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data inicial"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.filtros.data_inicial,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "data_inicial", $$v);
      },
      expression: "filtros.data_inicial"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": _vm.embedded ? 6 : 3
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data final"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.filtros.data_final,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "data_final", $$v);
      },
      expression: "filtros.data_final"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": _vm.embedded ? 6 : 3
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Regime"
    }
  }, [_c('b-form-select', {
    model: {
      value: _vm.filtros.regime,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "regime", $$v);
      },
      expression: "filtros.regime"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": "competencia"
    }
  }, [_vm._v("Competência")]), _c('b-form-select-option', {
    attrs: {
      "value": "caixa"
    }
  }, [_vm._v("Caixa")])], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": _vm.embedded ? 6 : 3
    }
  }, [_c('CentroCustoSelect', {
    attrs: {
      "label": "Filtrar centro de custo",
      "allow-create": false
    },
    model: {
      value: _vm.filtros.id_centro_custo,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "id_centro_custo", $$v);
      },
      expression: "filtros.id_centro_custo"
    }
  })], 1)], 1), _c('div', {
    staticClass: "d-flex justify-content-between align-items-center flex-wrap mb-5"
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.filtros.incluir_sem_centro,
      callback: function callback($$v) {
        _vm.$set(_vm.filtros, "incluir_sem_centro", $$v);
      },
      expression: "filtros.incluir_sem_centro"
    }
  }, [_vm._v("Incluir despesas sem centro de custo")]), _c('div', {
    staticClass: "d-flex mt-2 mt-md-0"
  }, [_c('button', {
    staticClass: "btn btn-primary mr-2",
    attrs: {
      "disabled": _vm.carregando || _vm.gerandoPdf
    },
    on: {
      "click": _vm.gerar
    }
  }, [_vm.carregando ? _c('b-spinner', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Visualizar ")], 1), _c('button', {
    staticClass: "btn btn-light-primary",
    attrs: {
      "disabled": _vm.carregando || _vm.gerandoPdf
    },
    on: {
      "click": _vm.gerarPdf
    }
  }, [_vm.gerandoPdf ? _c('b-spinner', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" Gerar PDF ")], 1)])], 1), _vm.relatorio ? [_c('b-row', {
    staticClass: "mb-5"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "resumo"
  }, [_c('small', [_vm._v("Total de lançamentos")]), _c('strong', [_vm._v(_vm._s(_vm.relatorio.quantidade))])])]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "resumo"
  }, [_c('small', [_vm._v("Total geral")]), _c('strong', [_vm._v(_vm._s(_vm.moeda(_vm.relatorio.total_geral)))])])]), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "resumo"
  }, [_c('small', [_vm._v("Centros encontrados")]), _c('strong', [_vm._v(_vm._s(_vm.relatorio.centros_custos.length))])])])], 1), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-head-custom table-vertical-center"
  }, [_vm._m(1), _c('tbody', [_vm._l(_vm.relatorio.centros_custos, function (grupo) {
    return [_c('tr', {
      key: "grupo-".concat(grupo.id_centro_custo || 'sem'),
      staticClass: "cursor-pointer",
      on: {
        "click": function click($event) {
          return _vm.alternar(grupo);
        }
      }
    }, [_c('td', {
      staticClass: "font-weight-bold"
    }, [_vm._v(_vm._s(grupo.nome))]), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(grupo.quantidade))]), _c('td', {
      staticClass: "text-right font-weight-bolder"
    }, [_vm._v(_vm._s(_vm.moeda(grupo.total)))])]), _vm.abertos[_vm.chave(grupo)] ? _c('tr', {
      key: "detalhe-".concat(grupo.id_centro_custo || 'sem')
    }, [_c('td', {
      staticClass: "p-0",
      attrs: {
        "colspan": "3"
      }
    }, [_c('table', {
      staticClass: "table table-sm mb-0 bg-light"
    }, [_c('tbody', _vm._l(grupo.lancamentos || [], function (item) {
      return _c('tr', {
        key: "".concat(item.origem, "-").concat(item.id)
      }, [_c('td', [_vm._v(_vm._s(_vm.formatarData(item.data)))]), _c('td', [_vm._v(_vm._s(item.descricao || item.documento || '-'))]), _c('td', [_vm._v(_vm._s(item.fornecedor || '-'))]), _c('td', {
        staticClass: "text-right"
      }, [_vm._v(_vm._s(_vm.moeda(item.valor)))])]);
    }), 0)])])]) : _vm._e()];
  }), _vm.relatorio.centros_custos.length === 0 ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Nenhuma despesa encontrada.")])]) : _vm._e()], 2)])])] : _vm._e()], 2)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('h3', {
    staticClass: "card-title font-weight-bolder text-dark mb-1"
  }, [_vm._v("Relatório por centro de custos")]), _c('div', {
    staticClass: "text-muted"
  }, [_vm._v("Analise as despesas agrupadas por período")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Centro de custo")]), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Lançamentos")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Total")])])]);
}];
export { render, staticRenderFns };